import React, { useState } from 'react';
import PremiumToggle from './PremiumToggle';
import AddCredits from './AddCredits';
import AllPages from './AllPages';

import Academy from './Academy';
import UploadLogs from './UploadLogs';
import ComplianceLogs from './ComplianceLogs';
import AccountDataTransfer from './AccountDataTransfer';
import WarmupSeedManager from './WarmupSeedManager';
import MonthlyCredits from './MonthlyCredits';
import ActivityWatchlist from './ActivityWatchlist';
import AiCostOverview from './AiCostOverview';
import ProviderAlertsBanner from './ProviderAlertsBanner';
import './TeamDashboard.css';

function TeamDashboard() {
    const [currentComponent, setCurrentComponent] = useState('PremiumToggle');

    const renderComponent = () => {
        switch (currentComponent) {
            case 'PremiumToggle':
                return <PremiumToggle />;
            case 'AddCredits':
                return <AddCredits />;
            case 'AllPages':
                return <AllPages />;

            case 'Academy':
                return <Academy />;
            case 'UploadLogs':
                return <UploadLogs />;
            case 'ComplianceLogs':
                return <ComplianceLogs />;
            case 'AccountDataTransfer':
                return <AccountDataTransfer />;
            case 'WarmupSeedManager':
                return <WarmupSeedManager />;
            case 'MonthlyCredits':
                return <MonthlyCredits />;
            case 'ActivityWatchlist':
                return <ActivityWatchlist />;
            case 'AiCostOverview':
                return <AiCostOverview />;
            default:
                return null;
        }
    };

    const navigationItems = [
        { key: 'PremiumToggle', label: 'BonusClub Members', icon: 'fa fa-crown' },
        { key: 'AddCredits', label: 'Add Credits', icon: 'fa fa-coins' },
        { key: 'MonthlyCredits', label: 'Memberships', icon: 'fa fa-calendar-alt' },
        { key: 'ActivityWatchlist', label: 'Activity Watchlist', icon: 'fa fa-eye' },
        { key: 'AiCostOverview', label: 'AI Cost', icon: 'fa fa-microchip' },
        { key: 'AllPages', label: 'All Pages', icon: 'fa fa-file-alt' },

        { key: 'Academy', label: 'Academy', icon: 'fa fa-graduation-cap' },
        { key: 'UploadLogs', label: 'Upload Logs', icon: 'fa fa-cloud-upload-alt' },
        { key: 'ComplianceLogs', label: 'Compliance Logs', icon: 'fa fa-shield-alt' },
        { key: 'AccountDataTransfer', label: 'Data Transfer', icon: 'fa fa-exchange-alt' },
        { key: 'WarmupSeedManager', label: 'Warmup Seeds', icon: 'fa fa-fire' }
    ];

    return (
        <div className="team-dashboard-container">
            <div className="team-dashboard-layout">
                <div className="team-dashboard-sidebar">
                    {navigationItems.map((item) => (
                        <button
                            key={item.key}
                            onClick={() => setCurrentComponent(item.key)}
                            className={`team-dashboard-tab ${currentComponent === item.key ? 'active' : ''}`}
                        >
                            <div className="team-dashboard-tab-icon"><i className={item.icon}></i></div>
                            <span className="team-dashboard-tab-text">{item.label}</span>
                        </button>
                    ))}
                </div>
                <div className="team-dashboard-content">
                    <ProviderAlertsBanner />
                    {renderComponent()}
                </div>
            </div>
        </div>
    );
}

export default TeamDashboard;